import styled from"../../styled-components";import{space,position,flex,textAlign,color,border,layout}from"styled-system";export const Box=styled.div`
  max-width: 100%;
  ${space}
  ${layout}
  ${position}
  ${flex}
  ${textAlign}
  ${color}
  ${border}
`;